import { t } from '@/i18n/i18ns'

export default {
  name: 'plan-card-discovery',
  components: {},
  props: {},
  data () {
    return {}
  },
  watch: {},
  computed: {
    mainFeatures () {
      return [
      `${t('planCard.oneUser')}`,
      `${t('planCard.oneGBStorage')}`,
      `${t('planCard.nineTemplates')}`
      ]
    }
  },
  methods: {},
  mounted () {}
}
